import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 5693BB52-A00A-45E6-8DDD-C84FE3D9D440
 * name file-export
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-export.svg
 * tags
 * - Files / Folders 
 */
export const FileExportIcon = createSvgIcon(<><path d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" /></>, 'FileExportIcon');
export default FileExportIcon